import React from "react";
import Topbar from "../../components/Super Admin/TopBar/TopbarQuestionnaire";
import HistoricalQuestionsTable from "../../components/Super Admin/Questionnaire Management/HistoricalQuestionsTable";

const HistoricalQuestionsPage: React.FC = () => {
  return (
    <>
      <Topbar />
      <HistoricalQuestionsTable />
    </>
  );
};

export default HistoricalQuestionsPage;
